package ru.villawonka.app.resources

import androidx.compose.ui.text.intl.Locale
import ru.villawonka.app.domain.model.LanguageDomain
import ru.villawonka.app.resources.strings.StringFactory
import ru.villawonka.app.resources.strings.StringResources

object AppResources {
    var strings: StringResources = StringFactory.createStrings(
        when (Locale.current.language) {
            "ru" -> LanguageDomain.RU
            else -> LanguageDomain.EN
        }
    )
        private set

    fun setLanguage(language: LanguageDomain) {
        strings = StringFactory.createStrings(language)
    }
}